import { render, staticRenderFns } from "./OffsetHeading.vue?vue&type=template&id=3dd0522c&scoped=true&"
import script from "./OffsetHeading.vue?vue&type=script&lang=js&"
export * from "./OffsetHeading.vue?vue&type=script&lang=js&"
import style0 from "./OffsetHeading.vue?vue&type=style&index=0&id=3dd0522c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0522c",
  null
  
)

export default component.exports